<template>
  <v-container>
    <v-toolbar flat color="primary">
      <v-toolbar-title class="white--text">{{
        $t('invoices_list')
      }}</v-toolbar-title>
    </v-toolbar>
    <v-data-table :headers="headers" :items="items" class="elevation-1">
      <template v-slot:items="props">
        <td>{{ props.item.VarSymbol }}</td>
        <td>{{ props.item.Subject }}</td>
        <td>
          {{
            parseFloat(props.item.TotalValue)
              .toFixed(2)
              .replace('.', ',')
          }}
          Kč
        </td>
        <td>
          {{
            new Date(props.item.CreateDate).toLocaleDateString('cs-CS', {
              timeZone: 'Europe/Prague'
            })
          }}
        </td>
        <td>
          {{
            new Date(props.item.TaxDate).toLocaleDateString('cs-CS', {
              timeZone: 'Europe/Prague'
            })
          }}
        </td>
        <td class="justify-center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                @click="downloadInvoice(props.item.Id, props.item.CreateDate)"
                >save_alt</v-icon
              >
            </template>
            <span>{{ $t('downld_tip') }}</span>
          </v-tooltip>
        </td>
        <td class="justify-center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-show="!props.item.InvoiceIsAccounted"
                @click="regenerateInvoice(props.item.Id)"
                v-on="on"
                >refresh</v-icon
              >
            </template>
            <span>{{ $t('regen_tip') }}</span>
          </v-tooltip>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      headers: [
        {
          text: this.$t('varsymbol'),
          align: 'left',
          sortable: true,
          value: 'VarSymbol'
        },
        { text: this.$t('subject'), value: 'Subject' },
        { text: this.$t('totalvalue'), value: 'TotalValue' },
        { text: this.$t('createdate'), value: 'CreateDate' },
        { text: this.$t('taxdate'), value: 'TaxDate' },
        { text: this.$t('download'), value: 'download' },
        { text: this.$t('regeneration'), value: 'regeneration' }
      ],
      items: [],
      inv: null,
      options: { year: 'numeric', month: 'numeric', day: 'numeric' },
      blob: null
    }
  },
  methods: {
    initialize() {
      this.loadInvoices()
    },
    async loadInvoices() {
      this.$root.$loader(true)
      try {
        let res = await this.axios.get(
          this.$providerURL + '/Api/Invoice/GetInvoiceList'
        )
        this.items = res.data.Items
      } catch (error) {
        this.$root.$gerror(error.response.data)
      } finally {
        this.$root.$loader(false)
      }
    },
    async downloadInvoice(id, crDate) {
      this.$root.$loader(true)
      try {
        let res = await this.axios.get(
          `${this.$providerURL}/Api/Invoice/GetInvoiceDocument?invoiceId=${id}`
          // {
          //   responseType: 'arraybuffer',
          //   headers: {
          //     'Content-Type': 'application/json; charset=utf-8',
          //     Accept: 'application/json'
          //   }
          // }
        )
        await this.downLink(res.data, crDate)
      } catch (error) {
        this.$root.$gerror(error.response.data)
      } finally {
        this.$root.$loader(false)
      }
    },
    async downLink(data, datum) {
      const date = datum
      const file = data
      //Build a URL from the file
      // const fileURL = URL.createObjectURL(file)
      let link = document.createElement('a')
      link.href = `data:application/pdf;base64,${file}`
      link.download = `Faktura_${new Date(date).toLocaleDateString('cs-CS', {
        timeZone: 'Europe/Prague'
      })}.pdf`
      link.setAttribute('target', '_blank')
      link.setAttribute('download', link.download)
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    async regenerateInvoice(id) {
      this.$root.$loader(true)
      try {
        let res = await this.axios.get(
          `${
            this.$providerURL
          }/Api/Invoice/RecreateInvoiceDocument?invoiceId=${id}`
        )
      } catch (error) {
        this.$root.$gerror(error.response.data)
      } finally {
        this.$root.$loader(false)
      }
    }
  },
  mounted() {
    this.initialize()
  }
}
</script>
